import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kindergarten-blog',
  templateUrl: './kindergarten-blog.component.html',
  styleUrls: ['./kindergarten-blog.component.scss']
})
export class KindergartenBlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
